var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.064,
    fill: "CurrentColor",
    height: 14.064,
    viewBox: "0 0 14.064 14.064",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_40788",
    "data-name": "Path 40788",
    d: "M12.685,3.082H11.607v-.8A2.281,2.281,0,0,0,9.323,0H4.734a2.3,2.3,0,0,0-2.3,2.283v.8H1.371A1.376,1.376,0,0,0,0,4.462v8.219a1.378,1.378,0,0,0,1.371,1.383H12.686a1.384,1.384,0,0,0,1.379-1.383V4.462A1.383,1.383,0,0,0,12.685,3.082Zm-8.4-.8a.446.446,0,0,1,.448-.453H9.323a.452.452,0,0,1,.455.453v.8H4.286Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.8b4c410e.svg";
export { ForwardRef as ReactComponent };